import { SystemView } from "@redotech/redo-model/conversation-filters/system-view";

const systemViewToDisplayNameMap: Record<SystemView, string> = {
  [SystemView.ALL]: "Open",
  [SystemView.ASSIGNED]: "Assigned to me",
  [SystemView.MENTIONS]: "Mentions",
  [SystemView.DRAFTS]: "Drafts",
  [SystemView.SENT]: "Sent",
  [SystemView.SPAM]: "Spam",
  [SystemView.CREATE]: "Create",
};

export const viewUrlNameToDisplayName = (viewName: SystemView | string) => {
  if (viewName in systemViewToDisplayNameMap) {
    return systemViewToDisplayNameMap[viewName as SystemView];
  }

  return viewName;
};

/**
 * Set of system view display names (lowercase) for collision detection.
 * Used to check if a custom view name collides with a system view display name.
 */
export const systemViewDisplayNames = new Set(
  Object.values(systemViewToDisplayNameMap).map((name) => name.toLowerCase()),
);
